import { View, Text } from "react-native";
import React from "react";
import TestSectionIcon from "../../assets/svg/TestSectionIcon";
import MyText from "../custom/MyText";
import BabyIcon from "../../assets/svg/BabyIcon";
import translate from "../../functions/translate";
import TestCalendarIcon from "../../assets/svg/TestCalendarIcon";
import MyButton from "../custom/MyButton";
import CircleChart from "../../assets/svg/CircleChart";
import ProgressBar from "../custom/ProgressBar";
import ResultIcon from "../../assets/svg/ResultIcon";
import GalleryIcon from "../../assets/svg/GalleryIcon";

import { white } from "../../colors";
import { useNavigation } from "@react-navigation/native";
import { useSelector } from "react-redux";
import { Video } from "expo-av";
import childrenList from "../../api/get/childrenList";
import { useState } from "react";
import { useEffect } from "react";
import MyVideo from "../../components/MyVideo";

const Participated = ({
  color,
  questionCount,
  details,
  part,
  answer,
  childId,
}) => {
  const navigation = useNavigation();
  const main = useSelector((store) => store.main);
  const descriptionText = main.rtl
    ? answer.descreptionsFa
    : answer.descreptionsEn;
  const videoUrl = main.rtl ? answer.urlFa : answer.urlEn;
  const [childChatDetail, setChildChatDetail] = useState({});
  const [childDetail, setChildDetail] = useState({});

  useEffect(() => {
    childrenList()
      .then(({ data }) => {
        if (data.status === 200) {
          //console.log(childId, data.data);
          const children = data.data.filter((item) => item.id === childId);
          //console.log(children);

          if (children.length > 0) {
            setChildDetail(children[0]);
            const chats = children[0].listCounseling;
            if (chats.length > 0) {
              setChildChatDetail(chats[0]);
            }
          }
        }
      })
      .catch((err) => {});
  }, []);
  //console.log(childChatDetail);
  //console.log(childDetail);
  return (
    <View style={{ width: "100%", alignItems: "center" }}>
      <View
        style={{
          width: "94%",
          flexDirection: "row",
          alignItems: "center",
          marginTop: 10,
        }}
      >
        <CircleChart color={color} />
        <MyText style={{ marginHorizontal: 5, fontSize: 13, marginTop: 3 }}>
          {translate("answered questions")}
        </MyText>
        <View style={{ flex: 1, marginHorizontal: 5 }}>
          <View style={{ flexDirection: "row" }}>
            <MyText
              style={{ marginHorizontal: 1, fontSize: 12 }}
            >{`${answer.countAnswered}`}</MyText>
            <MyText style={{ marginHorizontal: 1, fontSize: 12 }}>
              {translate("from")}
            </MyText>
            <MyText
              style={{ marginHorizontal: 1, fontSize: 12 }}
            >{`${answer.countQuestion}`}</MyText>
            <MyText style={{ marginHorizontal: 1, fontSize: 12 }}>
              {translate("question")}
            </MyText>
          </View>
          <View
            style={{
              width: "100%",
              padding: 1,
              backgroundColor: "#eee",
              borderRadius: 30,
            }}
          >
            <ProgressBar
              color={color}
              progress={(answer.countAnswered / answer.countQuestion) * 100}
            />
          </View>
        </View>
      </View>
      {(descriptionText !== null || descriptionText !== "") && (
        <View style={{ width: "94%", marginTop: 10 }}>
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <ResultIcon color={color} />
            <MyText
              style={{
                marginHorizontal: 3,
                color: color,
                marginTop: 3,

                fontSize: 16,
              }}
            >
              {translate("test result")}
            </MyText>
          </View>
          <View style={{ width: "100%", marginTop: 10 }}>
            <MyText
              fontFamily={"vazir"}
              style={{ fontSize: 15 }}
            >{`${descriptionText}`}</MyText>
          </View>
        </View>
      )}
      {videoUrl !== null && videoUrl !== "" && (
        <View style={{ width: "94%", marginTop: 10 }}>
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <GalleryIcon color={color} />
            <MyText
              style={{
                marginHorizontal: 3,
                color: color,
                marginTop: 3,
                fontWeight: "bold",
                fontSize: 16,
              }}
            >
              {translate("description video")}
            </MyText>
          </View>
          <View style={{ width: "100%", marginTop: 10, alignItems: "center" }}>
            <MyVideo url={videoUrl} />
          </View>
        </View>
      )}
      {main.rtl && details.answered.needRefer && (
        <View
          style={{
            marginVertical: 10,
            width: "100%",
            alignItems: "center",
          }}
        >
          <MyButton
            text="دریافت مشاوره"
            onPress={() => {
              if (childChatDetail.counselingId === undefined) {
                navigation.navigate("ConsultationNavigator", {
                  screen: "Consultation",
                  initial: false,
                  params: {
                    childId: childDetail.id,
                    childName: childDetail.name,
                    childImage: childDetail.image,
                    childGender: childDetail.gender,
                  },
                });
              } else {
                navigation.navigate("ConsultationNavigator", {
                  screen: "Chat",
                  initial: false,
                  params: {
                    childId: childDetail.id,
                    childName: childDetail.name,
                    childImage: childDetail.image,
                    childGender:
                      childDetail.gender === "boy" ? "male" : "female",
                    id: childChatDetail.counselingId,
                  },
                });
              }
            }}
          />
        </View>
      )}
    </View>
  );
};

const NotParticipated = ({
  color,
  questionCount,
  details,
  part,
  childId,
  testId,
}) => {
  const navigation = useNavigation();

  return (
    <View style={{ width: "100%", alignItems: "center" }}>
      <View
        style={{
          marginTop: 10,
          width: "95%",
          backgroundColor: "#F9F9F9",
          alignItems: "center",
          flexDirection: "row",
          padding: 10,
          borderRadius: 15,
          borderWidth: 1,
          borderColor: "#dcdcdc",
          minHeight: 30,
        }}
      >
        <View
          style={{
            width: 35,
            height: 35,
            borderRadius: 20,

            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <View style={{ transform: [{ scale: 1.4 }] }}>
            <CircleChart color={color} />
          </View>
        </View>
        <MyText style={{ marginHorizontal: 7 }}>
          {translate("number of questions")}
        </MyText>
        <View style={{ flex: 1 }}></View>
        <MyText>{`${questionCount}`}</MyText>
        <MyText style={{ marginHorizontal: 3 }}>{translate("question")}</MyText>
      </View>

      <View
        style={{
          width: "96%",
          flexDirection: "row",
          marginTop: 20,
          marginBottom: 10,
        }}
      >
        <View style={{ flex: 1 }}></View>
        <MyButton
          onPress={() =>
            navigation.navigate("DoTest", {
              screen: "TestStartInfo",
              initial: false,
              params: {
                details: details,
                type: "ASQ3",
                part: part,
                userDetails: { childId: childId, testId: testId },
              },
            })
          }
          style={{ backgroundColor: color, paddingVertical: 10 }}
          text={translate("do test")}
        />
      </View>
    </View>
  );
};

export default function TestPart({
  index,
  part,
  questionCount,
  details,
  participated,
  answer,
  childId,
  testId,
}) {
  const colorList = ["#48A9C2", "#FF9356", "#A7CA8D", "#9371BE"];
  const myColor = colorList[index % 4];
  return (
    <View
      style={{
        width: "100%",
        borderWidth: 1,
        borderColor: myColor,
        padding: 10,
        borderRadius: 10,
        marginVertical: 7,
      }}
    >
      <View style={{ flexDirection: "row", marginTop: -10 }}>
        <View
          style={{
            backgroundColor: myColor,
            borderBottomLeftRadius: 10,
            borderBottomRightRadius: 10,
            padding: 5,
            paddingHorizontal: 10,
            flexDirection: "row",
          }}
        >
          <MyText style={{ color: white }}>{`${translate(part)}`}</MyText>
        </View>
      </View>
      {participated && (
        <Participated
          answer={answer}
          color={myColor}
          questionCount={questionCount}
          details={details}
          part={part}
          childId={childId}
        />
      )}
      {!participated && (
        <NotParticipated
          color={myColor}
          questionCount={questionCount}
          details={details}
          part={part}
          childId={childId}
          testId={testId}
        />
      )}
    </View>
  );
}
